<template>
  <v-card
    :width="width"
    class="overflow-hidden card-video"
  >
    <v-img v-if="video.preview_url"
         class="d-block"
         width="100%"
         :src="video.preview_url"
    >
    </v-img>
    <video v-else-if="video.url"
        class="d-block"
        width="100%"
        playsinline
        autoplay
        :src='video.url'
        ref="videoPreview"
    />
    <v-container v-else class="converting-status grey lighten-2">
      <v-row
          class="fill-height"
          align-content="center"
          justify="center"
      >
        <v-col class="text-center" cols="12">
          Preview preparation
        </v-col>
        <v-col class="text-center text-truncate" cols="12">
          {{ video.original_name }}
        </v-col>
        <v-col cols="6">
          <div
              v-if="video.status === $constants.VIDEO_STATUSES.ERROR"
              class="text-center red--text"
          >
            Error
          </div>
          <v-progress-linear
              v-else
              indeterminate
              rounded
          ></v-progress-linear>
        </v-col>
      </v-row>
    </v-container>

    <v-dialog
        v-if="playable && video.url"
        v-model="showPlayDialog"
        width="initial"
        eager
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          class="play-button"
          fab x-small
          v-bind="attrs"
          v-on="on"
          @click="init = true"
        >
          <v-icon>mdi-play</v-icon>
        </v-btn>
      </template>
      <v-card>
        <video
            v-if="init"
            class="d-block"
            style="height:70vh"
            controls
            autoplay
            playsinline
            loop
            :src='video.url'
            @loadeddata="loadedDialogVideo"
            ref="videoInDialog"
        />
        <v-btn
            class="close-button"
            fab x-small
            @click="showPlayDialog = false"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card>
    </v-dialog>

    <div class="menu-button">
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn x-small fab v-bind="attrs" class="mr-2" v-on="on">
            <v-icon>
              mdi-information-variant
            </v-icon>
          </v-btn>
        </template>
        {{ video.original_name }}
      </v-tooltip>

      <v-btn
        v-if="hasDeleteListener && video.status !== $constants.VIDEO_STATUSES.ACCEPTED &&
        ((deletable && video.url) || video.status === $constants.VIDEO_STATUSES.ERROR)"
        x-small fab
        @click="deleteVideo"
      >
        <v-icon color="red">
          mdi-delete
        </v-icon>
      </v-btn>
    </div>

    <div class="text-center" v-if="!video.url && video.preview_url">
      Converting video
    </div>

    <div class="video-name" v-if="video.original_name">
    </div>

    <slot></slot>

  </v-card>
</template>

<script>
export default {
  name: "VideoCard",
  props: {
    width: {
      type: Number,
      default: 200
    },
    video: {
      type: Object,
      default: () => {}
    },
    playable: {
      type: Boolean,
      default: true
    },
    deletable: {
      type: Boolean,
      default: false
    },
  },
  mounted() {
    // hot fix for load preview on ios
    if (this.$refs.videoPreview) {
      this.$refs.videoPreview.addEventListener("playing", () => {
        this.$refs.videoPreview.currentTime = 0.001;
        this.$refs.videoPreview.pause();
      });
    }
  },
  data: () => ({
    showPlayDialog: false,
    init: false,
  }),
  computed:{
    hasDeleteListener() {
      return this.$listeners && this.$listeners.deleteVideo
    }
  },
  methods: {
    deleteVideo() {
      this.$emit('deleteVideo', this.video.id);
    },

    loadedDialogVideo() {
      this.$refs.videoInDialog.play();
    },
  },
  watch:{
    showPlayDialog: function(newValue) {
      if (!newValue) {
        this.$refs.videoInDialog.pause();
      } else if (this.$refs.videoInDialog) {
        this.$refs.videoInDialog.play();
      }
    }
  }
};
</script>

<style scoped>
.card-video {
}
.converting-status {
  height: 200px;
}
.play-button {
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 1;
}
.menu-button {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 1;
}
.close-button {
  position: absolute;
  top: 10px;
  right: 10px;
}
.video-name {
  position: absolute;
  bottom: 40px;
  right: 10px;
  z-index: 1;
}
</style>
